// extracted by mini-css-extract-plugin
export default {"login":"styles_login__OlPyr","login__logo":"styles_login__logo__ueWqV","login__button":"styles_login__button__E06ZV"};